import React from 'react';
import { NewReferralReviewStep } from 'pages/components';

const ARReferralFinalReview = (props) => (
  <NewReferralReviewStep {...props} />
);

export default ARReferralFinalReview;
